import {TcddWagonTitle} from '../enums/index-map/tcdd-wagon-title.enum';

export class TcddTrainWagonsIndexManagerUtil {
  /**
   * A template list of all possible wagon titles in their defined order.
   */
  private static wagonTitlesTemplate: string[] = [
    TcddWagonTitle.SKA1,
    TcddWagonTitle.OA1,
    TcddWagonTitle.OA1_1,
    TcddWagonTitle.OA4,
    TcddWagonTitle.OA1_2,
    TcddWagonTitle.OA2,
    TcddWagonTitle.OA3,
    TcddWagonTitle.SKA2
  ];

  /**
   * Mapping of wagon sizes to their specific title -> index mappings.
   * Key: number of wagons, Value: object mapping title enum to index.
   */
  private static wagonIndexes = {
    3: {
      [TcddWagonTitle.SKA1]: 0,
      [TcddWagonTitle.OA3]: 1,
      [TcddWagonTitle.SKA2]: 2
    },
    4: {
      [TcddWagonTitle.SKA1]: 0,
      [TcddWagonTitle.OA1]: 1,
      [TcddWagonTitle.OA3]: 2,
      [TcddWagonTitle.SKA2]: 3
    },
    5: {
      [TcddWagonTitle.SKA1]: 0,
      [TcddWagonTitle.OA1]: 1,
      [TcddWagonTitle.OA2]: 2,
      [TcddWagonTitle.OA3]: 3,
      [TcddWagonTitle.SKA2]: 4
    },
    6: {
      [TcddWagonTitle.SKA1]: 0,
      [TcddWagonTitle.OA1]: 1,
      [TcddWagonTitle.OA1_1]: 2,
      [TcddWagonTitle.OA2]: 3,
      [TcddWagonTitle.OA3]: 4,
      [TcddWagonTitle.SKA2]: 5
    },
    8: {
      [TcddWagonTitle.SKA1]: 0,
      [TcddWagonTitle.OA1]: 1,
      [TcddWagonTitle.OA1_1]: 2,
      [TcddWagonTitle.OA4]: 3,
      [TcddWagonTitle.OA1_2]: 4,
      [TcddWagonTitle.OA2]: 5,
      [TcddWagonTitle.OA3]: 6,
      [TcddWagonTitle.SKA2]: 7
    }
  };

  /**
   * Returns the full template of wagon titles.
   * @returns An array of wagon title strings in defined order.
   */
  static getWagonTitlesTemplate(): string[] {
    return this.wagonTitlesTemplate;
  }

  /**
   * Retrieves the index of a specific wagon based on its size and title.
   * @param wagonSize The size of the wagon (e.g., 3, 4, 5, 6, 8).
   * @param wagonTitle The title of the wagon (e.g., 'SKA1', 'OA1', etc.).
   * @returns The index of the wagon or undefined if not found.
   */
  static getWagonIndex(wagonSize: number, wagonTitle: TcddWagonTitle): number | null {
    const sizeMapping = this.wagonIndexes[wagonSize];
    if (!sizeMapping) {
      console.warn(`Wagon size ${wagonSize} is not recognized.`);
      return null;
    }
    return sizeMapping[wagonTitle] ?? null;
  }

  /**
   * Retrieves all wagon indexes for a given wagon size.
   * @param wagonSize The size of the wagon (e.g., 3, 4, 5, 6).
   * @returns An object containing all wagon titles and their corresponding indexes for the given size.
   */
  static getIndexesForWagonSize(wagonSize: number): Record<TcddWagonTitle, number> {
    return this.wagonIndexes[wagonSize] || {};
  }
}
